var map = {
	"./Approved.svg": 3795,
	"./AwaitingParts.svg": 3796,
	"./Closed.svg": 3797,
	"./Completed.svg": 3798,
	"./Excel.svg": 3799,
	"./Exportall_grey.svg": 3800,
	"./Exportall_grey_circle.svg": 3801,
	"./InProgress.svg": 3802,
	"./New.svg": 3803,
	"./View_Pic_Grey.svg": 3804,
	"./accident.svg": 3805,
	"./account.svg": 3806,
	"./addOrange.svg": 3807,
	"./addUser.svg": 3808,
	"./addVehicle.svg": 3809,
	"./address.svg": 3810,
	"./alert.svg": 3811,
	"./all_active.svg": 3812,
	"./all_active_es.svg": 3813,
	"./arrow-down.svg": 3814,
	"./arrow-up.svg": 3815,
	"./arrowRight.svg": 3816,
	"./awaiting_parts_grey.svg": 3817,
	"./awaiting_parts_orange.svg": 3818,
	"./back-btn.svg": 3819,
	"./back-button-grey.svg": 3820,
	"./backButton.svg": 3821,
	"./bills_of_landing_active.svg": 3822,
	"./bills_of_landing_active_es.svg": 3823,
	"./bobTail.svg": 3824,
	"./book-solid.svg": 3825,
	"./boxTruck.svg": 3826,
	"./calanderIcon.svg": 3827,
	"./cameraSelected.svg": 3828,
	"./camera_selected.svg": 3829,
	"./chat-icon.svg": 3830,
	"./circle-Exportall_grey.svg": 3831,
	"./circle-export.svg": 3832,
	"./circle-exportUser.svg": 3833,
	"./circle-import.svg": 3834,
	"./circle-importUser.svg": 3835,
	"./circle-viewall.svg": 3836,
	"./clearAll.svg": 3837,
	"./close-popup.svg": 3838,
	"./closeMap.svg": 3839,
	"./closed-Orange.svg": 3840,
	"./closed-grey.svg": 3841,
	"./clusterIcon.svg": 3842,
	"./communication_records_active.svg": 3843,
	"./communication_records_active_es.svg": 3844,
	"./company.svg": 3845,
	"./companyIcon.svg": 3846,
	"./complete-Orange.svg": 3847,
	"./complete-grey.svg": 3848,
	"./csa.svg": 3849,
	"./csaSnapshot.svg": 3850,
	"./dailyDocuments.svg": 3851,
	"./dashboard.svg": 3852,
	"./dashboardIcon.svg": 3853,
	"./date.svg": 3854,
	"./delete.svg": 3855,
	"./deleteCircle.svg": 3856,
	"./delivery_receipts_active.svg": 3857,
	"./delivery_receipts_active_es.svg": 3858,
	"./departments.svg": 3859,
	"./departmetEdit.svg": 3860,
	"./developer.svg": 3861,
	"./direction.svg": 3862,
	"./dispatch_records_active.svg": 3863,
	"./dispatch_records_active_es.svg": 3864,
	"./document.svg": 3865,
	"./documents.svg": 3866,
	"./dot.svg": 3867,
	"./dotAudit.svg": 3868,
	"./dotauditIcon.svg": 3869,
	"./downarrowIcon.svg": 3870,
	"./download.svg": 3871,
	"./downloadCenter.svg": 3872,
	"./downloadCenterMenu.svg": 3873,
	"./driver-behaviour.svg": 3874,
	"./driver.svg": 3875,
	"./dryVan.svg": 3876,
	"./dtc.svg": 3877,
	"./dualCam.svg": 3878,
	"./dump.svg": 3879,
	"./edit.svg": 3880,
	"./editLogIcon.svg": 3881,
	"./editSvg.svg": 3882,
	"./en.svg": 3883,
	"./es.svg": 3884,
	"./excelNew.svg": 3885,
	"./export-grey.svg": 3886,
	"./export.svg": 3887,
	"./exportUser.svg": 3888,
	"./feedback.svg": 3889,
	"./file-pdf-regular.svg": 3890,
	"./filter.svg": 3891,
	"./flatBed.svg": 3892,
	"./fleet.svg": 3893,
	"./fleetCompanies.svg": 3894,
	"./fleetdriverIcon.svg": 3895,
	"./fleetvehiclesIcon.svg": 3896,
	"./fletBed.svg": 3897,
	"./fuel.svg": 3898,
	"./full.svg": 3899,
	"./hamburger.svg": 3900,
	"./help-icon.svg": 3901,
	"./historyLogs.svg": 3902,
	"./icon-delete.svg": 3903,
	"./icon-export.svg": 3904,
	"./icon-menu-logs.svg": 3905,
	"./ifta.svg": 3906,
	"./import.svg": 3907,
	"./importUser.svg": 3908,
	"./in_progress_grey.svg": 3909,
	"./in_progress_orange.svg": 3910,
	"./infoTruck.svg": 3911,
	"./inspection-dvir.svg": 3912,
	"./inspection.svg": 3913,
	"./key.svg": 3914,
	"./leftArrow.svg": 3915,
	"./location.svg": 3916,
	"./locationMap.svg": 3917,
	"./log.svg": 3918,
	"./logEdit.svg": 3919,
	"./logHistory.svg": 3920,
	"./logoutIcon.svg": 3921,
	"./logs.svg": 3922,
	"./logsIcon.svg": 3923,
	"./mack.svg": 3924,
	"./mail.svg": 3925,
	"./main_camera.svg": 3926,
	"./mappinPopup.svg": 3927,
	"./menu_companies.svg": 3928,
	"./menu_dailyLog.svg": 3929,
	"./menu_reports.svg": 3930,
	"./menu_reseller.svg": 3931,
	"./menu_vehicle.svg": 3932,
	"./messageSender.svg": 3933,
	"./messaging.svg": 3934,
	"./new_login.svg": 3935,
	"./ninePin.svg": 3936,
	"./nonEdit.svg": 3937,
	"./notFull.svg": 3938,
	"./not_started_grey.svg": 3939,
	"./not_started_orange.svg": 3940,
	"./otherTrailer.svg": 3941,
	"./otherTruck.svg": 3942,
	"./other_documents_active.svg": 3943,
	"./other_documents_active_es.svg": 3944,
	"./overview.svg": 3945,
	"./page-first.svg": 3946,
	"./page-last.svg": 3947,
	"./page-next.svg": 3948,
	"./page-prev.svg": 3949,
	"./phone.svg": 3950,
	"./pickup.svg": 3951,
	"./pneumaticTrailer.svg": 3952,
	"./policy.svg": 3953,
	"./popupClose.svg": 3954,
	"./popupConfirm.svg": 3955,
	"./popupDelete.svg": 3956,
	"./privatePassenger.svg": 3957,
	"./qbdii.svg": 3958,
	"./receipts_active.svg": 3959,
	"./receipts_active_es.svg": 3960,
	"./reeferTrailer.svg": 3961,
	"./refreshCircle.svg": 3962,
	"./renewal.svg": 3963,
	"./repair.svg": 3964,
	"./reportIcon.svg": 3965,
	"./reports.svg": 3966,
	"./save-regular.svg": 3967,
	"./scoreCard.svg": 3968,
	"./searchGrey.svg": 3969,
	"./selectedConnection.svg": 3970,
	"./share.svg": 3971,
	"./sixPin.svg": 3972,
	"./sort.svg": 3973,
	"./speedometer.svg": 3974,
	"./spotlightGreen.svg": 3975,
	"./spotlightGrey.svg": 3976,
	"./spotlightRed.svg": 3977,
	"./straightTruck.svg": 3978,
	"./supportIcon.svg": 3979,
	"./switch.svg": 3980,
	"./tankerTrailer.svg": 3981,
	"./tick.svg": 3982,
	"./time.svg": 3983,
	"./timePicker.svg": 3984,
	"./toggle-off.svg": 3985,
	"./toggle-on.svg": 3986,
	"./tools.svg": 3987,
	"./tractorDayCab.svg": 3988,
	"./tractorSleeper.svg": 3989,
	"./undelete.svg": 3990,
	"./unsaved.svg": 3991,
	"./update.svg": 3992,
	"./upload.svg": 3993,
	"./usdot.svg": 3994,
	"./user.svg": 3995,
	"./userprofileIcon.svg": 3996,
	"./users.svg": 3997,
	"./vacuumTrailer.svg": 3998,
	"./vacuumTruck.svg": 3999,
	"./van.svg": 4000,
	"./vehicle-behaviour.svg": 4001,
	"./vehicle.svg": 4002,
	"./vehicleIcon.svg": 4003,
	"./viewArrow.svg": 4004,
	"./viewDocument.svg": 4005,
	"./viewReports.svg": 4006,
	"./viewStatus.svg": 4007,
	"./viewallMap.svg": 4008,
	"./violation.svg": 4009,
	"./volvo.svg": 4010,
	"./weigh_tickets_active.svg": 4011,
	"./weigh_tickets_active_es.svg": 4012,
	"./whitecheck_new.svg": 4013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3794;